import React from "react";
import { LinkButton } from "@/features/shell/components/shared/LinkButton/LinkButton";
import {
  useStaticEntries,
  usePendingBetsCount,
} from "@/hooks/firestore/betting/useEntries";
import type { BetslipTab } from "@/features/betslip/stores/slices/tab";

import * as styles from "@/features/betslip/components/EntriesFooter.module.scss";

type EntriesFooterProps = {
  tab: Exclude<BetslipTab, "active">;
};

/**
 * Footer link from the in-slip Pending/Settled lists to the full
 * entries pages. Hidden when the list is empty.
 */
export const EntriesFooter = ({ tab }: EntriesFooterProps) => {
  const { entries: settledEntries } = useStaticEntries(10);
  const pendingBetsCount = usePendingBetsCount("BET");

  const hasPendingEntries = pendingBetsCount > 0;
  const hasSettledEntries = (settledEntries?.length ?? 0) > 0;
  const hasEntries = tab === "pending" ? hasPendingEntries : hasSettledEntries;

  if (!hasEntries) return null;

  return (
    <div className={styles.footer}>
      <LinkButton
        to={tab === "pending" ? "/entries/live/" : "/entries/historical"}
        className={styles.button}
        size="md"
      >
        View All
      </LinkButton>
    </div>
  );
};
